import { __awaiter } from "tslib";
import { ref } from 'vue';
import ApiManager from '@/managers/apimanagers';
export const API_TYPE_VIEW = 'view';
export const API_TYPE_EDIT = 'edit';
export const APPROVAL_STATUS_WAITING = 'waiting';
export const APPROVAL_STATUS_ACTIVE = 'active';
export const APPROVAL_STATUS_REJECT = 'reject';
export const APPROVAL_STATUS_SUSPENDED = 'suspended';
/**
 * @summary API申請
 */
export const useApiApproval = () => {
    const isLoading = ref(false);
    /**
     * @returns API申請データの取得
     */
    const getApiApproval = () => __awaiter(void 0, void 0, void 0, function* () {
        let res;
        try {
            isLoading.value = true;
            res = yield ApiManager.get(`/api-approval`);
        }
        finally {
            isLoading.value = false;
        }
        return res;
    });
    const postApiApproval = () => __awaiter(void 0, void 0, void 0, function* () {
        let res;
        try {
            isLoading.value = true;
            res = yield ApiManager.post(`/api-approvals`, {});
        }
        finally {
            isLoading.value = false;
        }
        return res;
    });
    return { isLoading, getApiApproval, postApiApproval };
};
